var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLongLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.97495 15.6834C7.81662 15.6834 7.65828 15.6251 7.53328 15.5001L2.47495 10.4418C2.23328 10.2001 2.23328 9.8001 2.47495 9.55843L7.53328 4.5001C7.77495 4.25843 8.17495 4.25843 8.41662 4.5001C8.65828 4.74176 8.65828 5.14176 8.41662 5.38343L3.79995 10.0001L8.41662 14.6168C8.65828 14.8584 8.65828 15.2584 8.41662 15.5001C8.29995 15.6251 8.13328 15.6834 7.97495 15.6834Z",
    fill: "#A2ABB4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0833 10.625H3.05835C2.71668 10.625 2.43335 10.3417 2.43335 10C2.43335 9.65833 2.71668 9.375 3.05835 9.375H17.0833C17.425 9.375 17.7083 9.65833 17.7083 10C17.7083 10.3417 17.425 10.625 17.0833 10.625Z",
    fill: "#A2ABB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongLeftArrow);
export default __webpack_public_path__ + "static/media/long-left-arrow.e5052d5e17e4215abb7577bdef40d769.svg";
export { ForwardRef as ReactComponent };